import React from 'react';
import { motion } from 'framer-motion';

interface LevelCompleteProps {
  level: number;
  score: number;
  wordsFound: number;
  bonusPoints: number;
  tileClearingBonus?: number;
  allWordsFound?: boolean;
  onNextLevel: () => void;
  onReplay: () => void;
  onLevelSelect: () => void;
}

const LevelComplete: React.FC<LevelCompleteProps> = ({
  level,
  score,
  wordsFound,
  bonusPoints,
  tileClearingBonus = 0,
  allWordsFound = false,
  onNextLevel,
  onReplay,
  onLevelSelect
}) => {
  const allWordsFoundBonus = allWordsFound ? wordsFound * 25 : 0;

  return (
    <motion.div 
      className="level-complete-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <motion.div 
        className="level-complete-modal"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.5, opacity: 0 }}
        transition={{ type: "spring", duration: 0.25, bounce: 0.3 }}
      >
        <div className="celebration-header">
          <motion.div
            className="celebration-emoji"
            animate={{ 
              rotate: [0, -10, 10, -10, 10, 0],
              scale: [1, 1.2, 1, 1.2, 1]
            }}
            transition={{ duration: 0.6, repeat: 2 }}
          >
            🎉
          </motion.div>
          <h2>Level Complete!</h2>
        </div>

        <div className="completion-stats">
          <div className="stat-row">
            <span className="stat-label">Words Found:</span>
            <span className="stat-value">{wordsFound}</span>
          </div>
          <div className="stat-row">
            <span className="stat-label">Base Score:</span>
            <span className="stat-value">{score - bonusPoints - tileClearingBonus - allWordsFoundBonus}</span>
          </div>
          <div className="stat-row bonus">
            <span className="stat-label">Completion Bonus:</span>
            <span className="stat-value">+{bonusPoints}</span>
          </div>
          {tileClearingBonus > 0 && (
            <div className="stat-row bonus">
              <span className="stat-label">Tile Clearing Bonus:</span>
              <span className="stat-value">+{tileClearingBonus}</span>
            </div>
          )}
          {allWordsFound && (
            <div className="stat-row bonus">
              <span className="stat-label">All Words Found Bonus:</span>
              <span className="stat-value">+{allWordsFoundBonus}</span>
            </div>
          )}
          <div className="stat-row total">
            <span className="stat-label">Total Score:</span>
            <span className="stat-value">{score}</span>
          </div>
        </div>

        <div className="completion-actions">          
          <motion.button
            className="action-button next-level-button"
            onClick={onNextLevel}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Next Level
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default LevelComplete;
